import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { ProposalDto, useEditProposal } from "../../http";
import { CreateEditProposalForm, ICreateEditProposalFormState } from "./CreateEditProposalForm";

interface IProps {
  visible: boolean;
  proposal: ProposalDto;
  issueGuid: string;
  onUpdated: () => void;
  onCancelled: () => void;
}

const EditProposalModal = (props: IProps) => {
  const { mutate: editProposal, isLoading: isUpdatingProposal } = useEditProposal();

  const { formState, control, handleSubmit, reset } = useForm<ICreateEditProposalFormState>({
    defaultValues: {
      description: props.proposal.description ?? "",
      notes: props.proposal.note ?? "",
    },
  });

  useEffect(() => {
    reset({
      description: props.proposal.description ?? "",
      notes: props.proposal.note ?? "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.proposal]);

  async function handleUpdateClicked() {
    handleSubmit((data) => {
      editProposal(
        {
          proposalGuid: props.proposal.guid,
          issueGuid: props.issueGuid,
          description: data.description,
          notes: data.notes,
        },
        {
          onSuccess: () => {
            props.onUpdated();
          },
        },
      );
    })();
  }

  function handleClose(_: object, reason: string) {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }

    handleCancelClicked();
  }

  function handleCancelClicked() {
    reset(undefined, { keepDefaultValues: true });
    props.onCancelled();
  }

  return (
    <Dialog open={props.visible} onClose={handleClose}>
      <DialogTitle>Edit Proposal</DialogTitle>
      <DialogContent>
        <CreateEditProposalForm formState={formState} control={control} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancelClicked} disabled={isUpdatingProposal}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleUpdateClicked}
          disabled={isUpdatingProposal}
          endIcon={isUpdatingProposal ? <CircularProgress size={20} sx={{ color: "grey.400" }} /> : null}
        >
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { EditProposalModal };
